import React from 'react';
import { Button } from 'react-bootstrap';
import { BsColumnsGap, BsXLg } from 'react-icons/bs';
import '../Widgets.scss';

interface HeaderActionWidgetProps {
	t: (key: string) => string;
	editMode?: boolean;
	iseditable?: boolean;
	currentBreakpoint?: string;
	handleEditFunction?: () => void;
	handleClose?: () => void;
	setShowModal?: (show: boolean) => void;
	setShowConformationModal?: (show: boolean) => void;
	setIsRestoreDefault?: (isRestore: boolean) => void;
	setShowNoFeatureModal?: (show: boolean) => void;
	handleSaveLaunchpadConfig?: () => void;
	isLoading?: boolean;
	hasCustomizationPermission?: boolean;
}

const HeaderActionWidget: React.FC<HeaderActionWidgetProps> = ({
	t,
	editMode = false,
	iseditable = false,
	currentBreakpoint = '',
	handleEditFunction = () => {},
	handleClose = () => {},
	setShowModal = () => {},
	setShowConformationModal = () => {},
	setIsRestoreDefault = () => {},
	setShowNoFeatureModal = () => {},
	handleSaveLaunchpadConfig = () => {},
	isLoading = false,
	hasCustomizationPermission = false,
}) => {
	const isMobile = ['md', 'sm', 'xs', 'xxs', 'xxxs'].includes(
		currentBreakpoint,
	);

	return (
		<>
			{isLoading ? (
				<div
					className={`d-flex align-items-center float-end p-1 ${isMobile && 'w-100'}`}
				>
					{hasCustomizationPermission && (
						<Button
							className={`customize-button create-content-button d-flex align-items-center ${isMobile && 'w-100 justify-content-center'} gap-2 ${!isMobile ? 'me-2' : ''}`}
							variant="outline-secondary"
						>
							<BsColumnsGap /> <span>{t('customizeLaunchpad')}</span>
						</Button>
					)}
					{!isMobile && (
						<button
							className="close-button closebutton bg-white p-0 border-0 d-flex align-items-center justify-content-center"
							onClick={handleClose}
						>
							<BsXLg />
						</button>
					)}
				</div>
			) : editMode ? (
				<div className="d-none d-sm-flex align-items-center gap-2 action-buttons-container float-end p-1">
					<Button
						className="text-capitalize"
						variant="primary"
						onClick={() => handleSaveLaunchpadConfig()}
					>
						{t('saveChanges')}
					</Button>
					<Button
						className="text-capitalize"
						id="restoreDefaultLayout"
						variant="outline-secondary"
						onClick={() => {
							setShowConformationModal(true);
							setIsRestoreDefault(true);
						}}
					>
						{t('restoreDefaultLayout')}
					</Button>
					<Button
						className="d-flex align-items-center gap-1"
						variant="outline-primary"
						onClick={() => setShowModal(true)}
					>
						<span>{t('settings')}</span>
					</Button>
					<Button
						className="text-capitalize"
						variant="outline-secondary"
						onClick={() => {
							setShowConformationModal(true);
							setIsRestoreDefault(false);
						}}
					>
						{t('cancel')}
					</Button>
				</div>
			) : hasCustomizationPermission && iseditable ? (
				<div
					className={`d-flex align-items-center float-end p-1 ${isMobile && 'w-100'}`}
				>
					<Button
						className={`customize-button create-content-button  d-flex align-items-center ${isMobile && 'w-100 justify-content-center'} gap-2 ${!isMobile ? 'me-2' : ''}`}
						variant="outline-secondary"
						onClick={() => handleEditFunction()}
					>
						<BsColumnsGap /> <span>{t('customizeLaunchpad')}</span>
					</Button>
					{!isMobile && (
						<button
							className="close-button closebutton bg-white p-0 border-0 d-flex align-items-center justify-content-center"
							onClick={handleClose}
						>
							<BsXLg />
						</button>
					)}
				</div>
			) : hasCustomizationPermission ? (
				<div
					className={`d-flex align-items-center float-end p-1 ${isMobile && 'w-100'}`}
				>
					<Button
						className={`customize-button create-content-button d-flex align-items-center ${isMobile && 'w-100 justify-content-center'} gap-2 ${!isMobile ? 'me-2' : ''}`}
						variant="outline-secondary"
						onClick={() => setShowNoFeatureModal(true)}
					>
						<BsColumnsGap /> <span>{t('customizeLaunchpad')}</span>
					</Button>
					{!isMobile && (
						<button
							className="close-button closebutton bg-white p-0 border-0 d-flex align-items-center justify-content-center"
							onClick={handleClose}
						>
							<BsXLg />
						</button>
					)}
				</div>
			) : (
				<div
					className={`d-flex align-items-center float-end p-1 ${isMobile && 'w-100'}`}
				>
					{!isMobile && (
						<button
							className="close-button closebutton bg-white p-0 border-0 d-flex align-items-center justify-content-center"
							onClick={handleClose}
						>
							<BsXLg />
						</button>
					)}
				</div>
			)}
		</>
	);
};

export default HeaderActionWidget;
